
/**
 * Adds loadmore functionality to a group block with the is-style-loadmore class.
 */
function initGroupLoadmore() {
    const groups = document.querySelectorAll( '.is-style-loadmore' );
    if ( ! groups ) {
        return;
    }

    groups.forEach( (group) => {
        const button = document.createElement( 'button' );
        button.classList.add( 'btn', 'btn--navy-bg', 'btn--green-arrow', 'group-loadmore-button' );
        button.innerText = "See More";
        button.addEventListener( 'click', handleClick );

        group.insertBefore( button, group.firstChild );
    });
}

/**
 * show the loadmore content
 */
function handleClick( e ) {
    e.preventDefault();
    const group      = e.target.parentNode;
    group.classList.add( 'loadmore--open' );
}

export {
    initGroupLoadmore
}
